import React from "react";
import PropTypes from "prop-types";
import styles from "./CreateAllModal.module.css";
import ModalActionBar from "shared/ModalActionBar";
import { Modal } from "shared/Modal";
import CheckBoxItem from "../../../Shared/CheckBoxItem";

/**
 * Interactive component. Modal used for creating a new account for all active premier members.
 */

export function CreateAllModal({ isOpen, onClose, onClick, checked }) {
  return (
    <div className={styles.container}>
      <Modal
        isOpen={isOpen}
        title="CREATE ALL"
        closeBtn="none"
        className={styles.modal}
      >
        <div className={styles.contentContainer}>
          <p className={styles.send}>
            Create new user accounts for all active Premier members who don't
            yet have one.
          </p>
          <div className={styles.emailContainer}>
            <CheckBoxItem
              checked={checked}
              name="Attempt to create account again even if errors were encountered on a previous attempt"
              onClick={() => {}}
            />
          </div>
        </div>
        <div className={styles.btnContainer}>
          <ModalActionBar
            children={
              <div className={styles.btnDiv}>
                <button
                  type="button"
                  className={styles.cancelBtn}
                  onClick={onClose}
                >
                  CANCEL
                </button>
                <button
                  type="button"
                  className={styles.resendBtn}
                  onClick={onClick}
                >
                  CREATE ALL
                </button>
              </div>
            }
          />
        </div>
      </Modal>
    </div>
  );
}

CreateAllModal.propTypes = {
  /**
   * Boolean to determine if modal is open
   */
  isOpen: PropTypes.bool,
  /**
   * Callback function for when the modal is closed.
   */
  onClose: PropTypes.func,
  /**
   * Function called when create all is clicked
   */
  onClick: PropTypes.func,
  /**
   * 	True if checkbox is checked
   */
  checked: PropTypes.bool,
};
